var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart"},[_c('Chart',{attrs:{"extendData":_vm.extendData,"height":_vm.height,"id":_vm.id,"option":_vm.option,"width":_vm.width,"route":_vm.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }